/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeocodingResult
 */
export interface GeocodingResult {
    /**
     * 
     * @type {string}
     * @memberof GeocodingResult
     */
    city?: string;
}

/**
 * Check if a given object implements the GeocodingResult interface.
 */
export function instanceOfGeocodingResult(value: object): value is GeocodingResult {
    return true;
}

export function GeocodingResultFromJSON(json: any): GeocodingResult {
    return GeocodingResultFromJSONTyped(json, false);
}

export function GeocodingResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeocodingResult {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'] == null ? undefined : json['city'],
    };
}

export function GeocodingResultToJSON(value?: GeocodingResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'city': value['city'],
    };
}

